import styled from '@emotion/styled'
export const StyleGrid = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyleGridItem = styled.div`
  background: ${(props: any) => props.theme.colors.white100};
  height: 160px;
  border-radius: 8px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`
